export const DYNAMIC_ENUM_EDITOR = "/settings-menu/dynamic-enums";
